import { ViewModel,View } from "binder"
import  { IconView } from "./icon-view"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { ClassListPropertyType, StringPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";


export class IconComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Icon';
        this.canAcceptContent = false;
        this.canAcceptMultipleContent = false;

        this.addProperty("IconClass","data-b-class-additioanl",new ClassListPropertyType(this),null,false);
    }

    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    protected getClassDefaultValue(){
        return "";
    }

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new IconElement(parent);
        return result;
    }
        
}
export class IconElement extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new IconView();
    }
    public getTypeId(): string {
        return "VM-E031831B-D1EA-42F9-AA72-3AEC0D1250DF"
    }
    public set IconClass(v: string) { this._IconClass = v; } public get IconClass(): string { return this._IconClass;} private _IconClass: string;
    
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitIcon(this,parameter);
    }

}
